// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var PMSVertical;
(function (PMSVertical) {
    PMSVertical["PMS_VERTICAL_UNSPECIFIED"] = "PMS_VERTICAL_UNSPECIFIED";
    PMSVertical["PMS_VERTICAL_VET"] = "PMS_VERTICAL_VET";
    PMSVertical["PMS_VERTICAL_DENTAL"] = "PMS_VERTICAL_DENTAL";
    PMSVertical["PMS_VERTICAL_OTHER"] = "PMS_VERTICAL_OTHER";
})(PMSVertical || (PMSVertical = {}));
export var PMSVertical_index;
(function (PMSVertical_index) {
    PMSVertical_index[PMSVertical_index["PMS_VERTICAL_UNSPECIFIED"] = 0] = "PMS_VERTICAL_UNSPECIFIED";
    PMSVertical_index[PMSVertical_index["PMS_VERTICAL_VET"] = 1] = "PMS_VERTICAL_VET";
    PMSVertical_index[PMSVertical_index["PMS_VERTICAL_DENTAL"] = 2] = "PMS_VERTICAL_DENTAL";
    PMSVertical_index[PMSVertical_index["PMS_VERTICAL_OTHER"] = 100] = "PMS_VERTICAL_OTHER";
})(PMSVertical_index || (PMSVertical_index = {}));
export var WritebackStatus;
(function (WritebackStatus) {
    WritebackStatus["WRITEBACK_STATUS_UNSPECIFIED"] = "WRITEBACK_STATUS_UNSPECIFIED";
    WritebackStatus["WRITEBACK_STATUS_QUEUED"] = "WRITEBACK_STATUS_QUEUED";
    WritebackStatus["WRITEBACK_STATUS_SUCCESS"] = "WRITEBACK_STATUS_SUCCESS";
    WritebackStatus["WRITEBACK_STATUS_FAILURE"] = "WRITEBACK_STATUS_FAILURE";
})(WritebackStatus || (WritebackStatus = {}));
export var WritebackStatus_index;
(function (WritebackStatus_index) {
    WritebackStatus_index[WritebackStatus_index["WRITEBACK_STATUS_UNSPECIFIED"] = 0] = "WRITEBACK_STATUS_UNSPECIFIED";
    WritebackStatus_index[WritebackStatus_index["WRITEBACK_STATUS_QUEUED"] = 1] = "WRITEBACK_STATUS_QUEUED";
    WritebackStatus_index[WritebackStatus_index["WRITEBACK_STATUS_SUCCESS"] = 2] = "WRITEBACK_STATUS_SUCCESS";
    WritebackStatus_index[WritebackStatus_index["WRITEBACK_STATUS_FAILURE"] = 3] = "WRITEBACK_STATUS_FAILURE";
})(WritebackStatus_index || (WritebackStatus_index = {}));
export const SMSWritebackService = {
    /**
     * WritebackMessages allows a user to write back one or more SMS messages to a PMS.
     */
    WritebackMessages(fn, req) {
        return fn(`/sms/writeback/v1/writeback-messages`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetNoteStatus(fn, req) {
        return fn(`/sms/writeback/v1/note-status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListPMSPersons(fn, req) {
        return fn(`/sms/writeback/v1/pms-persons?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CanSMSWriteback(fn, req) {
        return fn(`/sms/writeback/v1/can-sms-writeback?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
